import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaWhatsapp } from 'react-icons/fa';
import '../../../styles/WhatsappDetailsModal.css';
import { useAuthContext } from '../../../context/AuthContext';

const WhatsappDetailsModal = ({ show, handleClose, message }) => {
  const { isAuthenticated } = useAuthContext();

  if (!message) return null;

  if (!isAuthenticated) return null;

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="lg" className="whatsapp-modal">
        <Modal.Header closeButton className="border-0">
          <Modal.Title>
            <FaWhatsapp className="me-2" style={{ color: '#25D366' }} />
            Message Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <Form>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Recipient Name</Form.Label>
                  <Form.Control type="text" readOnly value={message.recipientName || message.name || 'N/A'} className="bg-light" />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Phone Number</Form.Label>
                  <Form.Control type="text" readOnly value={message.phoneNumber || message.number || 'N/A'} className="bg-light" />
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Status</Form.Label>
                  <Form.Control type="text" readOnly value={message.statusText || message.status || 'N/A'} className="bg-light" />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Date & Time</Form.Label>
                  <Form.Control type="text" readOnly value={message.muda || 'N/A'} className="bg-light" />
                </Form.Group>
              </div>
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Full Message</Form.Label>
              <Form.Control as="textarea" rows={4} readOnly value={message.messageText || 'N/A'} className="bg-light" />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default WhatsappDetailsModal;
